import { ACTION_MODE } from "@pdfking/constants/alias"
import { FILE_ID } from "@pdfking/constants/alias"
import { FILE_KEY } from "@pdfking/constants/alias"
import { FILE_RANGE } from "@pdfking/constants/alias"
import { FILE_REFERENCE } from "@pdfking/constants/alias"
import { FILE_SCALE } from "@pdfking/constants/alias"
import { FILENAME } from "@pdfking/constants/alias"
import { PRINT_MODE } from "@pdfking/constants/alias"
import { SIZE } from "@pdfking/constants/alias"
import { TRUNCATED } from "@pdfking/constants/alias"
import { SWITCH_FILE_PREPRESS } from "@pdfking/constants/settings"
import { First } from "@pdfking/tfunc"
import imposition_plot from "@pdfking/workflow/actions/imposition_plot"
import split_pdf from "@pdfking/workflow/actions/split_pdf"
import add_b64_to_url from "@pdfking/workflow/actions/utils/add_b64_to_url"
import to_cm from "@pdfking/workflow/units/to_cm"
import object_map from "rfuncs/functions/object_map"
import scan from "rfuncs/functions/scan"
import values from "rfuncs/functions/values"

import new_file_from_virtualfile from "../../../files/make/new_file_from_virtualfile"
import get_django_url from "../../../utils/get_django_url"
import submit_action from "./submit_action"

const get_size_input = ({ width, height }) =>
  `${to_cm(width)}x${to_cm(height)} cm`

export const submit_prepress_files = (files, session = null) =>
  submit_action(
    SWITCH_FILE_PREPRESS,
    object_map(
      f => f.path,
      f => f,
      files
    ),
    session
  )
export const make_prepress_url_from_file = async (f, print_mode, processor) => {
  const url = await get_django_url(
    print_mode ? "imposition_prepress_blank" : "imposition_prepress"
  )

  const { page_count, trim_box } = await First(split_pdf(await f.get_file()))

  const endpoint = add_b64_to_url(url, {
    [FILE_KEY]: [
      {
        [FILE_ID]: f.short_name,
        [FILE_SCALE]: "sketch",
        [FILE_RANGE]: page_count == 1 ? "1" : "1-2",
      },
    ],
    [SIZE]: get_size_input(trim_box),
    [ACTION_MODE]: "single_pdf",
    [TRUNCATED]: "off",
    [FILENAME]: f.basename,
    [FILE_REFERENCE]: f.short_name,
    [PRINT_MODE]: print_mode || (page_count == 1 ? "f" : "fr"),
  })

  return processor(endpoint)
}

export default async (print_mode, files_dict, session = null) => {
  const files = []

  for (const f of values(files_dict)) {
    await make_prepress_url_from_file(f, print_mode, imposition_url =>
      imposition_plot({
        imposition_url,
        filenames: { [f.short_name]: f.get_file() },
      }).then(all =>
        scan(
          (file, path) => files.push(new_file_from_virtualfile({ file, path })),
          all
        )
      )
    )
  }

  return submit_prepress_files(files, session)
}
